export const quotes = [
    {
      quote:
        "You must be the change you wish to see in the world. – Mahatma Gandhi"
    },
    {
      quote:
        "First they ignore you, then they laugh at you, then they fight you, then you win. – Mahatma Gandhi"
    },
    {
      quote:
        "Those who are prepared to die for any cause are seldom defeated. - Pandit Jawarharlal Nehru"
    },
    {
      quote:
        "Where the mind is led forward by thee into ever-widening thought and action-Into that heaven of freedom, my father, let my country awake. – Rabindranath Tagore"
    },
    {
      quote:
        "A war based on Satyagraha is always of two kinds. One is the war we wage against injustice and the other we fight against our own weaknesses. – Sardar Vallabhbhai Patel"
    },
    {
      quote:
        "Revolution is an inalienable right of mankind. Freedom is an imperishable birthright of all. ― Bhagat Singh"
    },
    {
      quote:
        "Merciless criticism and independent thinking are the two necessary traits of revolutionary thinking. ― Bhagat Singh"
    },
    {
      quote:
        "Don’t take rest after your first victory because if you fail in second, more lips are waiting to say that your first victory was just luck. - A. P. J. Abdul Kalam"
    },
    {
      quote:
        "I believe in a religion that propagates freedom, equality and brotherhood. - Chandrasekhar Azad"
    },
    {
      quote:
        "Don’t see others doing better than you, beat your own records every day because success is a fight between you and yourself. - Chandrasekhar Azad"
    },
    {
      quote:
        "We want deeper sincerity of motive, a greater courage in speech and earnestness in action. - Sarojini Naidu"
    },
    {
      quote:
        "A country’s greatness lies in its undying ideals of love and sacrifice that inspire the mothers of the race. - Sarojini Naidu"
    },
    {
      quote:
        "Life is all about a card game. Choosing the right cards is not in our hand. But playing well with the cards in hand determines our success. - Bal Gangadhar Tilak"
    },
    {
      quote: "Life should be great rather than long. – B.R. Ambedkar"
    },
    {
      quote: "Ignorance is always afraid of change. – Pandit Jawaharlal Nehru"
    },
    {
      quote:
        "So long as you do not achieve social liberty, whatever freedom is provided by the law is of no avail to you. – B.R. Ambedkar"
    },
    {
      quote: "Wherever you go becomes a part of you somehow. – Anita Desai"
    },
    {
      quote:
        "Remember, no one is stopping you from lighting a lamp in a dark night. – Harivansh Rai Bacchan"
    },
    {
      quote:
        "What we possess is temporary, but what we become is permanent. – Devdutt Pattanaik"
    },
    {
      quote:
        "Man needs his difficulties because they are necessary to enjoy success. – A.P.J. Abdul Kalam"
    },
    {
      quote: "What is now in the past was once in the future. – Ramachandra Guha"
    },
    {
      quote:
        "They who give have all things; they who withhold have nothing. – Indian proverb"
    },
    {
      quote:
        "We can’t change the direction of the wind, but we can adjust the sails. – Indian proverb"
    },
    {
      quote:
        "Comfort is no test of truth. Truth is often far from being comfortable. – Swami Vivekananda"
    }
  ];
  